
export default {
  name: 'BBRadio',
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    name: String,
    onIcon: {
      type: String,
      default: 'icon-radio-checked-filled',
    },
    offIcon: {
      type: String,
      default: 'icon-radio-unchecked-outlined',
    },
    label: String,
    id: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#4e226e',
    },
    activeClass: String,
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedProps() {
      return {
        name: this.name,
        onIcon: this.onIcon,
        offIcon: this.offIcon,
        label: this.label,
        id: this.id,
        disabled: this.isDisabled,
        color: this.color,
        activeClass: this.activeClass,
        readonly: this.isReadonly,
        value: this.value,
      };
    },
  },
};
